import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SignupError } from "../../../common/redux/thunks/auth/signup-as-person-thunk";
import { OwnerIdentityFieldValues } from "./OwnerIdentityFields";

export function useSignupError<T extends FieldValues & OwnerIdentityFieldValues>(
  signupError: SignupError | string | null | undefined,
  methods: UseFormReturn<T>
) {
  const { t } = useTranslation();
  const toast = useToast();

  useEffect(() => {
    if (!signupError) {
      methods.clearErrors();
      return;
    }
    const emailField = "email" as Path<T>;
    const passwordField = "password" as Path<T>;
    switch (signupError) {
      case "EmailAlreadyTaken":
        methods.setError(emailField, { message: t("An account already belongs to this email.") ?? "" });
        return;
      case "WeakPassword":
        methods.setError(passwordField, {
          message: t("This password has been found in password breaches and you need to use another password.") ?? "",
        });
        return;
      case "PasswordBreached":
        methods.setError(passwordField, {
          message: t("This password has been found in password breaches and cannot be used.") ?? "",
        });
        return;
      case "SimilarToIdentifier":
        methods.setError(passwordField, { message: t("This password is too similar to your email.") ?? "" });
        return;
      case "UnknownError":
        toast({ title: t("Unknown error occurred, please try again."), status: "error" });
        return;
      default:
        toast.closeAll();
        toast({ title: t(signupError), status: "error" });
    }
  }, [signupError, methods, t, toast]);
}
